

export class SubclientVisibilitySettingSubclient {
  id?: number;
  subclientId: number;
  subclientVisibilitySettingId?: number;
}
